<template>
	<div class="wrap wrap--main">
		<!-- 헤더 -->
		<main-header :header-type="'shop'"></main-header>

		<!-- 메인 -->
		<main class="main" role="main">
			<!-- 쇼핑몰 비주얼 -->
            <main-banners code="store-main-pc" pc></main-banners>
            <main-banners code="store-main-mobile" mobile></main-banners>

            <!-- 새집 핫딜 -->
            <div v-show="showHotDeal" class="main-section main-section--orange main-section--hot">
                <div class="inner">
                    <div class="main-section-head">
                        <div class="left">
                            <h3 class="title">새집 <b>핫딜</b></h3>
                        </div>
                        <div class="right">
                            <a class="link" href="/shop/hot"><span>+ 더보기</span></a>
                        </div>
                    </div>
                    <div class="main-section-body">
						<!-- 쇼핑몰 메인 상품 슬라이드 : 1열 레이아웃 -->
						<main-exhibition code="special" @load="exhibitions => showHotDeal = 0 < exhibitions.length"></main-exhibition>
                    </div>
                </div>
            </div>
            
			<!-- 카테고리 -->
			<div class="main-section main-section--category">
				<div class="inner">
					<div class="main-section-head">
						<div class="left">
							<h3 class="title"><b>카테고리</b></h3>
						</div>
					</div>
					<div class="main-section-body">
						<!-- 카테고리 슬라이드 -->
						<main-categories></main-categories>
					</div>
				</div>
			</div>

			<!-- 새집 베스트 -->
			<div v-show="showBest" class="main-section main-section--orange main-section--best">
				<div class="inner">
					<div class="main-section-head">
						<div class="left">
							<h3 class="title">새집 <b>베스트</b></h3>
						</div>
						<div class="right">
							<router-link class="link" to="/shop/best"><span>+ 더보기</span></router-link>
						</div>
					</div>
					<div class="main-section-body">
						<!-- 쇼핑몰 메인 상품 슬라이드 : 2열 및 버튼 아웃 포지션 레이아웃 -->
						<main-exhibition-multi code="best" @load="exhibitions => showBest = 0 < exhibitions.length"></main-exhibition-multi>
					</div>
				</div>
			</div>

            <!-- 새집 신상품 -->
			<div v-show="showNewly" class="main-section main-section--orange main-section--best">
				<div class="inner">
					<div class="main-section-head">
						<div class="left">
							<h3 class="title">새집 <b>신상품</b></h3>
						</div>
						<div class="right">
						</div>
					</div>
					<div class="main-section-body">
						<!-- 쇼핑몰 메인 상품 슬라이드 : 2열 및 버튼 아웃 포지션 레이아웃 -->
						<main-exhibition-multi code="newly" @load="exhibitions => showNewly = 0 < exhibitions.length"></main-exhibition-multi>
					</div>
				</div>
			</div>

			<!-- 새집 기획전 -->
			<div v-if="showPlanning" class="main-section main-section--orange main-section--plan">
				<div class="inner">
					<div class="main-section-head">
						<div class="left">
							<h3 class="title">새집 <b>기획전</b></h3>
						</div>
						<div class="right">
							<a class="link" href="/shop/exhibition"><span>+ 더보기</span></a>
						</div>
					</div>
					<div class="main-section-body">
						<!-- 기획전 슬라이드 -->
						<main-plans></main-plans>
					</div>
				</div>
			</div>
			<!-- 배너 -->
			<div class="main-section">
				<div class="inner">
					<div class="ban-grid-container">
						<div class="grid">
							<div class="grid-12">
								<!-- 배너 : PC 좌측 -->
								<main-banners-grid code="store-lower-left"></main-banners-grid>
							</div>
							<div class="grid-12">
								<!-- 배너 : PC 우측 -->
								<main-banners-grid code="store-lower-right"></main-banners-grid>
							</div>
						</div>
					</div>
				</div>
			</div>
		</main>

		<!-- 푸터 -->
		<main-footer></main-footer>
	</div>
</template>

<script>
import MainHeader from "@/components/client/inc/main-header.vue";
import MainFooter from "@/components/client/inc/main-footer.vue";

import MainBanners from "@/components/client/shop/main-banners.vue";
import MainExhibition from "@/components/client/shop/main-exhibition.vue";
import MainExhibitionMulti from "@/components/client/shop/main-exhibition-multi.vue";
import MainCategories from "@/components/client/shop/main-categories.vue";
import MainPlans from "@/components/client/shop/main-plans.vue";
import MainBannersGrid from "@/components/client/shop/main-banners-grid.vue";

export default{
	components: {
		MainHeader,
		MainFooter,
		MainBanners,
		MainExhibition,
		MainExhibitionMulti,
		MainCategories,
		MainPlans,
		MainBannersGrid,
	},
    data(){
        return {
            showHotDeal: false,
            showBest: false,
            showNewly: false,
            showPlanning: false
        }
    },
}
</script>
